import { render, staticRenderFns } from "./LegalPersons.vue?vue&type=template&id=bd5797e2&scoped=true&"
import script from "./LegalPersons.vue?vue&type=script&lang=js&"
export * from "./LegalPersons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5797e2",
  null
  
)

export default component.exports